import React, { useState, useRef, useEffect } from 'react';

import { Avatar, Alert, FormControl, Input, InputLabel, ButtonGroup, Button, FormHelperText } from '@mui/material';

import ColumnLayout from '../layouts/ColumnLayout';

import { getUserApi, updateUserApi } from '../services/UserService';

import { deepPurple } from '@mui/material/colors';

import SaveIcon from '@mui/icons-material/Save';

export default function Profile() {
  const user_id = localStorage.getItem('user_id');
  
  const [user, setUser] = useState({
    username: '',
    email: '',
    email_verification_status: '',
    created_at: '',
    image: ''
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [avatarFile, setAvatarFile] = useState(false);
  const [usernameValid, setUsernameValid] = useState(true);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [username, setUsername] = useState('');
  const [userImage, setUserImage] = useState('');

  const hiddenFileInput = useRef();
  const usernameInputRef = useRef();

  const isEmpty = (value) => value?.trim() === '';

  const fetchHandler = () => {
    getUserApi(localStorage.getItem('token'), user_id)
      .then((data) => {
        //usernameInputRef.current.value = data.username;
        setUsername(data.username);
        setUserImage(data.image);
        setUser(data);
      }).catch((errors) => {
        // TODO: Handle errors
      });
  };

  useEffect(() => {
    fetchHandler();
  }, [user_id])

  const handleImportClick = event => {
    hiddenFileInput.current.click();
  };

  const handleChange = event => {
    setSelectedFile(event.target.files[0]);
    setAvatarFile(true);
  };

  const cleanAvatarFile = () => {
    hiddenFileInput.current.value = "";
    setSelectedFile(null);
    setAvatarFile(false);
  }

  const avatarHandler = async () => {
    const rest = await updateUserApi(localStorage.getItem('token'), localStorage.getItem('user_id'), { image: selectedFile })
      .then(async (data) => {
        setShowSuccessAlert(true);
        setUserImage(data.image);
        return true;
      }).catch((errors) => {
        setShowErrorAlert(true);     
        return errors
      });
    return rest;
  };

  useEffect(() => {
    if (avatarFile) {
      async function putData() {
        const rest = await avatarHandler();
        cleanAvatarFile();
      }
      putData();
    }
  }, [avatarFile])

  const stringToColor = (string) => {
    if (!string) {
      return deepPurple[500];
    }

    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }

  const saveHandler = async (event) => {
    event.preventDefault();

    const enteredUsername = username; //usernameInputRef.current.value;

    const enteredUsernameIsValid = !isEmpty(enteredUsername);

    setUsernameValid(enteredUsernameIsValid);

    const formIsValid = enteredUsernameIsValid;

    if (!formIsValid) {
      return;
    }

    let payload = {
      username: enteredUsername
    }

    const rest = await updateUserApi(localStorage.getItem('token'), localStorage.getItem('user_id'), payload)
      .then((data) => {
        return [true, data];
      }).catch((errors) => {
        return [false, errors];
      });

    if (rest[0]) {
      setShowSuccessAlert(true);
    } else {
      // TODO: Set errors in the form and change its messages
      // var params = {};
      // for (let key in rest[1]) {
      //   params[key] = true
      // }

      setShowErrorAlert(true);  
      // setFormInputsValidity(params);
    }
  };
  
  const onChangeUsername = () => {
    setUsername(usernameInputRef.current.value);
  }

  useEffect(() => {
    if (showSuccessAlert) {
      setTimeout(() => {
        setShowSuccessAlert(false)
      }, 3000);
    }

    if (showErrorAlert) {
      setTimeout(() => {
        setShowErrorAlert(false)
      }, 3000);
    }
  }, [showSuccessAlert, showErrorAlert])

  return (
    // TODO - Handle the profile picture via active storage and password/email recovering settings.
    <div>
      <ColumnLayout childs={[
        (showErrorAlert && <Alert severity="error">Error!</Alert>),
        (showSuccessAlert && <Alert severity="success">Éxito!</Alert>),
        (<h1>Perfil</h1>),
        (<input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{display: 'none'}}
        />),
        (<Avatar onClick={handleImportClick}
                 sx={{ bgcolor: stringToColor(user.username) }}
                 src={userImage}>
            {user.username.charAt(0).toUpperCase()}
          </Avatar>),
        (<div>
          <FormControl error={!usernameValid} variant="standard">
            <InputLabel htmlFor="username" className='input'>Username</InputLabel>
            <Input id="username" inputRef={usernameInputRef} className='input' onChange={onChangeUsername} value={username} />
            {!usernameValid && <FormHelperText>Username invalido o repetido!</FormHelperText>}
          </FormControl>
        </div>),
        (<p>Email: {user.email}</p>),
        (<p>EmailVerified: {String(user.email_verification_status)}</p>),
        (<p>CreatedAt: {user.created_at}</p>),
        (<ButtonGroup variant="">
          <Button variant="contained" startIcon={<SaveIcon />} sx={{ marginRight: 2 }} onClick={saveHandler}>SAVE</Button>
        </ButtonGroup>)
      ]} />
    </div>
  );
}
